import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { FUNDED_RETURN_TYPES, FUNDING_INSTRUMENTS, FUNDING_RETURN_TYPES, } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const equityOtcSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.EquityOtc),
    instrument_id: z.number().int().positive(),
    fund_id: z.number().int().positive(),
    currency_id: z.number().int().positive(),
    notional: z.number(),
    counterparty_id: z.number().int().positive(),
    trade_id: z.string().nullable(),
    effective_date: z.iso.date(),
    maturity_date: z.iso.date(),
    first_floater_settlement_date: z.iso.date(),
    penultimate_floater_settlement_date: z.iso.date(),
    cash_settlement_payment_date: z.iso.date(),
    funding_instrument: z.enum(FUNDING_INSTRUMENTS).nullable(),
    floater_spread_bps: z.number().int(),
    swap_payments_yearly: z.number().int().positive(),
    funding_return_type: z.enum(FUNDING_RETURN_TYPES),
    funded_return_type: z.enum(FUNDED_RETURN_TYPES),
});
